import { flushSync } from "react-dom"

// The next screen can mount its header a task or two after the step changes (signup shows a placeholder first), so the
// transition waits for that header before capturing it, but never longer than this.
const HEADER_WAIT_MS = 100

let resolveHeaderMounted: (() => void) | null = null
let arriving = false

export const notifyPhaseHeaderMounted = () => resolveHeaderMounted?.()

// True while the next screen's header mounts inside a transition, so it leaves the morph to the transition.
export const isPhaseArrival = () => arriving

// globals.css animates the `onboarding-phase-*` groups OnboardingHeader names: the current phase's circle fills into the next
// screen's blue step and the others shrink into its dots.
export const startPhaseTransition = (update: () => void) => {
  if (!document.startViewTransition || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    update()
    return
  }
  // The header scrolls with the screen, and its phases morph from where they are on screen: a scrolled screen goes back to it first.
  document.querySelector("header")?.scrollIntoView({ block: "nearest", behavior: "instant" })
  document.startViewTransition(() => {
    const headerMounted = new Promise<void>((resolve) => {
      resolveHeaderMounted = resolve
      setTimeout(resolve, HEADER_WAIT_MS)
    })
    arriving = true
    flushSync(update)
    return headerMounted.finally(() => {
      resolveHeaderMounted = null
      arriving = false
    })
  })
}
